import React from 'react'

export default function Instructors() {
    return (
        <div >
            <h1 className="text-center text-danger mt-3">
                Our Instructors
            </h1>
            <div className="row justify-content-center">
                <div className="col-6">
                    <div className="text-center">
                        <img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.machostyles.com%2Fwp-content%2Fuploads%2F2020%2F08%2FDapper-Beard-Styles-For-Bald-Men-8.jpg&f=1&nofb=1" className="border rounded-circle" height="300px" width="300px" alt="Instructor" />
                    </div>

                    <h4 className="text-success">
                        Md Hasibur Rahman
                    </h4>
                    <h5 className="text-info">
                        Title: Senior Software Engineer ar xyz Company
                    </h5>
                    <p>
                        I am a software engineer. I like to teach about new technologies. Becoming a part of such a community I feel honored.
                    </p>
                </div>

            </div>

        </div>
    )
}
